// Keep the picture playing even when the browser requires a click for sound.
export async function startPlayback(element: HTMLMediaElement, silentVideoFallback: boolean): Promise<boolean> {
  try { await element.play(); return false; }
  catch (error) {
    if (!(error instanceof Error) || error.name !== "NotAllowedError") throw error;
    if (silentVideoFallback) { element.muted = true; await element.play(); }
    return true;
  }
}
